module.exports = require('./dist/client').default;



//////////////////
// WEBPACK FOOTER
// ./~/@storybook/core/client.js
// module id = 1029
// module chunks = 0